import Qs from 'qs'
let baseURL = ''
let wxUrl = ''
if (process.env.TYPE === 'test') {
  // 预上线环境
  baseURL = 'https://boss-test.ideamake.cn/uc/api/v1/'
  wxUrl = 'https://boss-test.ideamake.cn/uc/oauth/callback/driver/wechat/client/6'
} else {
  if (process.env.NODE_ENV === 'production') {
    baseURL = 'https://uc.ideamake.cn/api/v1/'
    wxUrl = 'https://uc.ideamake.cn/oauth/callback/driver/wechat/client/6'
  } else {
    baseURL = 'https://boss-test.ideamake.cn/uc/api/v1/'
    wxUrl = 'https://boss-test.ideamake.cn/uc/oauth/callback/driver/wechat/client/6'
  }
}
export default {
  url: '/user',
  method: 'get',
  baseURL: baseURL,
  wxUrl: wxUrl,
  transformRequest: [function (data) {
    data = Qs.stringify(data)
    return data;
  }],

  transformResponse: [function (data) {
    return data
  }],
  timeout: 30000,

  responseType: 'json',

}



// WEBPACK FOOTER //
// ./src/fetch/configUser.js